import React from 'react';
import RecipientsSearchBar from './RecipientSearchBar';
import EmailPerformanceExportButton from './EmailPerformanceExportButton';

const emailTabs = ['Email', 'Performance', 'Recipients'];

function EmailPerformanceTabs({ activeTab, setActiveTab, searchValue, setSearchValue, emailId, emailSubject }) {
  return (
    <div className='d-flex align-items-center justify-content-between gap-25 flex-wrap specific-bottom-margin-23'>
      <div className='email-tabs-container-performance'>
        {emailTabs.map((tab, index) => {
          return (
            <div
              key={`${tab}-${index}`}
              data-testid={`email-tab-${tab.toLowerCase()}`}
              className={`email-tab-btn rounded-pill ${activeTab === tab ? 'email-tab-btn-active' : ''}`}
              onClick={() => {
                setActiveTab(tab);
              }}
            >
              {tab}
            </div>
          );
        })}
      </div>
      {(activeTab === 'Recipients' || activeTab === 'Performance') && (
        <div className='d-flex align-items-center gap-10 flex-grow-1 justify-content-end'>
          <div className='flex-grow-1'>
            {activeTab !== 'Performance' && (
              <RecipientsSearchBar searchValue={searchValue} setSearchValue={setSearchValue} />
            )}
          </div>
          <EmailPerformanceExportButton emailId={emailId} activeTab={activeTab} emailSubject={emailSubject} />
        </div>
      )}
    </div>
  );
}

export default EmailPerformanceTabs;
